<template>
  <div class="item-wrapper">
    <div
      class="item"
      @click="handleClick"
    >
      <div class="lt">
        <img
          :src="imgSrc"
          alt
        />
        <div class="rt text">
          <p class="color">{{title}}</p>
          <p class="c999">{{text}}</p>
        </div>
      </div>
      <div class="rt">
        <div v-if="isMintong">
          <img
            src="../assets/location.svg"
            alt
          />
          <p class="c999">服务网点</p>
        </div>
        <div
          class="rt big"
          v-else-if="isYuetong || isZhetong || isJitong || isGantong || isZhaoshang"
        >
          <img
            class="big_img"
            src="../assets/big.svg"
            alt
          />
          <p class="c999">查看</p>
        </div>
        <div v-else-if="isXiangtong">
          <div v-if="isWechatH5">
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_e29df2b1d9ab">
              <script type="text/wxtag-template">
                <style>.c999 { color: #999 }.active-text {font-size: 0.72rem}.img {width: 1.8rem;margin-bottom:10px}</style>
                <img class="img" src="data:image/png;base64,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" alt="">
                <p class="c999 active-text">激活</p>
              </script>
            </wx-open-launch-weapp>
          </div>
          <div v-else-if="isMiniprogram" @click.stop="miniprogramJump">
            <img src="../assets/active.png" alt="">
            <p class="c999 active-text">激活</p>
          </div>
          <div v-else>
            <img src="../assets/active.png" alt="">
            <p class="c999 active-text">激活</p>
          </div>
        </div>
        <div v-else-if="isAvaiale">
          <img
            src="../assets/视频.svg"
            alt
          />
          <p class="c999">激活视频</p>
        </div>
        <div
          class="rt bg"
          v-else
        >
          <p class="c999 ta">即将</p>
          <p class="c999 ta">推出</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  name: "productItem",
  props: {
    imgSrc: {
      type: String
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    isAvaiale: {
      type: Boolean
    },
    jumpParam: {
      type: String
    }
  },
  created () {
    if (this.isWechatH5) {
      console.log('这是在微信的网页')
    } else if (this.isMiniprogram) {
      console.log('这是在小程序里面')
    } else {
      console.log('都不是')
    }
    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.error(e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
    });
  },
  mounted () {
    var btn = document.getElementById('launch-btn');
    if (!btn) return
    btn.addEventListener('launch', function (e) {
      console.log('success', e);
    });
    btn.addEventListener('error', function (e) {
      console.log('fail', e.detail);
    });
  },
  computed: {
    isGantong () {
      return this.jumpParam === 'gantong'
    },
    isMintong () {
      return this.jumpParam === 'mintong'
    },
    isYuetong () {
      return this.jumpParam === 'yuetong'
    },
    isZhetong () {
      return this.jumpParam === 'zhetong'
    },
    isJitong () {
      return this.jumpParam === 'jitong'
    },
    isXiangtong () {
      return this.jumpParam === 'xiangtong'
    },
    isZhaoshang () {
      return this.jumpParam === 'zhaoshang'
    },
    isWechatH5 () {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") {return true && !this.isMiniprogram;} else {return false;}
    },
    isMiniprogram () {
      return window.__wxjs_environment === "miniprogram"
    }
  },
  methods: {
    miniprogramJump (x) {
      console.log(x, '跳转回小成都', window.wx.miniProgram.navigateTo)
      Dialog({
        message: '请前往金润二当家微信小程序首页进行激活操作'
      })
    },
    handleClick () {
      if (!this.isAvaiale) return;
      if (this.isGantong) {
        this.$router.push({
          name: 'gantong'
        })
        return
      }
      if (this.isMintong) {
        window.location.href = 'http://mintongbao.mgskj.com/GSTFuJianWeChatAPI/Home/ETC_Network'
        return
      }
      if (this.isYuetong) {
        this.$router.push({
          name: 'InstallationProcess'
        })
        return
      }
      if (this.isZhetong) {
        this.$router.push({
          name: 'ZTHaveOrder'
        })
        return
      }
      if (this.isJitong) {
        this.$router.push({
          name: 'jitong'
        })
        return
      }
      if (this.isZhaoshang) {
        this.$router.push({
          name: 'zhaoshang'
        })
        return
      }
      if (!this.isXiangtong) {
        this.$router.push({
          name: "about",
          params: {
            productName: this.jumpParam
          }
        });

      }
    }
  }
};
</script>

<style lang="scss" scoped>
.item-wrapper {
  padding-top: 0.2rem;
  background-color: #f5f5f5;
  &:nth-last-child(1) {
    padding-bottom: 0.2rem;
  }
}
.item {
  background-color: #fff;
  list-style: none;
  height: 2rem /* 100/50 */;
  padding: 0.5rem /* 25/50 */;

  height: 2rem /* 100/50 */;
  font-size: 0.5rem;
  color: #ccc;
}
.text {
  padding-top: 0.1rem /* 5/50 */;
  font-size: 0.48rem /* 24/50 */;
  p {
    height: 0.4rem /* 20/50 */;
    line-height: 0.4rem;
  }
  .color {
    color: rgb(54, 53, 53);
    font-size: 0.28rem;
  }
}

.rt {
  float: right;
  img {
    width: 0.6rem /* 30/50 */;
    margin-bottom: 0.1rem /* 5/50 */;
  }
}

.bg {
  border-radius: 0.16rem /* 8/50 */;
  width: 0.8rem /* 40/50 */;
  border: 0.04rem solid #ccc;
  p {
    color: rgb(65, 63, 63);
    height: 0.36rem /* 18/50 */;
    line-height: 0.36rem /* 18/50 */;
  }
}

.lt {
  float: left;
  img {
    width: 1.6rem /* 80/50 */;
    margin-right: 0.2rem /* 10/50 */;
  }
}
.c999 {
  color: rgb(121, 119, 119);
  text-align: left;
  &.ta {
    text-align: center;
    color: rgb(156, 155, 155);
  }
}

.big {
  .big_img {
    margin-bottom: 10px;
  }
}

.active-text {
  margin-top: 10px;
  text-indent: 2px;
}
</style>